import { useEffect, useState } from 'react';
import { getBlob } from '../../cache';
import type { MediaRef } from '../../types';

// Loads a blob from the IDB cache by sha256, creates an object URL,
// revokes on unmount/change. Returns null while loading or when the blob
// is absent (which shouldn't happen post-hydration but is defensive
// against cache invalidation or mid-render manifest swaps).
export function useBlobUrl(ref: MediaRef | null): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!ref) {
      setUrl(null);
      return;
    }
    let cancelled = false;
    let objectUrl: string | null = null;
    void (async () => {
      try {
        const blob = await getBlob(ref.sha256);
        if (cancelled || !blob) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      } catch {
        // Silent — caller renders fallback (null) gracefully
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [ref?.sha256]);

  return url;
}
